// AddModeDialog.js
import React from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { Help, QuestionAnswer, QuestionMarkSharp } from "@mui/icons-material";

export default function AddModeDialog({ open, onClose, onSelectMode }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose}>
      {/* <DialogTitle>Select Add Mode</DialogTitle> */}
      <DialogContent>
        <Box display="flex" justifyContent="center" justifyItems="center" gap={2} px={3} py={3}>
          <Help color="info" fontSize="large"/>
          <Typography variant="h5" color="info">{t("properties.how_add_units")}</Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="space-evenly" gap={4} mr={3} mb={2}>
          <Button
            color="success"
            variant="contained"
            sx={{ color: "#fff" }}
            onClick={() => onSelectMode("single")}
          >
            {t("properties.add_one_unit")}
          </Button>
          <Button
            color="success"
            variant="contained"
            sx={{ color: "#fff" }}
            onClick={() => onSelectMode("bulk")}
          >
            {t("properties.add_in_bulk")}
          </Button>
          {/* <Button onClick={onClose}>Close</Button> */}
        </Box>
      </DialogActions>
    </Dialog>
  );
}
